import { render, staticRenderFns } from "./EstimatedHours.vue?vue&type=template&id=47c8609d&"
import script from "./EstimatedHours.vue?vue&type=script&lang=js&"
export * from "./EstimatedHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports